import type { Transfer } from '@0xtorch/core'
import type { AssetBalance } from '../../types/assetBalance'
import type { AssetBorrow } from '../../types/assetBorrow'
import type { Loan } from '../../types/loan'
import type { Transaction } from '../../types/transaction'

type ReplaceBondOfTransfersParameters = {
  readonly actionId: string
  readonly timestamp: number
  readonly transfers: readonly Transfer[]
  readonly loans: Map<string, Loan>
  readonly assetBalances: Map<string, readonly AssetBalance[]>
  readonly assetBorrows: Map<string, readonly AssetBorrow[]>
  readonly usedBalances: Map<string, AssetBalance>
}

type ReplaceBondOfTransfersReturnTypes = {
  readonly transfers: readonly Transfer[]
  readonly transactions: readonly Transaction[]
  readonly loans: Map<string, Loan>
  readonly assetBalances: Map<string, readonly AssetBalance[]>
  readonly assetBorrows: Map<string, readonly AssetBorrow[]>
  readonly usedBalances: Map<string, AssetBalance>
}

export const replaceBondOfTransfers = ({
  transfers,
  loans,
  assetBalances,
  assetBorrows,
  usedBalances,
}: ReplaceBondOfTransfersParameters): ReplaceBondOfTransfersReturnTypes => {
  return {
    transfers,
    transactions: [],
    loans,
    assetBalances,
    assetBorrows,
    usedBalances,
  }
  // transfer 毎に処理
  // bond が無くなるまで繰り返し
  // TODO
  // bond = asset な lend data を含む loan を見つける
  // - Loan を加工して、bond token 毎の loanId, lend index を見つける

  // lend を使用して、bond transfer を lend transfers + repayment & withdraw transactions に変換

  // 使用した分の lend を減らして loan 更新
}
